import React, { useEffect, useRef } from 'react';
import './DeskCanvas.scss';
import { sizeCanvas, cssSize } from '../../utils/canvasSize';

const DeskCanvas = () => {
  // desk（奥の机）と desk2（最前面の机）は別 canvas に分ける。
  // 間にキャラを挟めるようにするため（zIndex 8 < キャラ < 10）
  const canvasRef = useRef(null);
  const canvas2Ref = useRef(null);
  const deskImageRef = useRef(null);
  const desk2ImageRef = useRef(null);
  const loadedCount = useRef(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    const canvas2 = canvas2Ref.current;
    const ctx = canvas.getContext('2d');
    const ctx2 = canvas2.getContext('2d');

    const resizeCanvas = () => {
      // 実ピクセルは画面密度に合わせる（スマホでの粗さ対策）
      [canvas, canvas2].forEach((c) => {
        sizeCanvas(c, window.innerWidth, window.innerHeight);
      });
      drawDesk();
    };

    const calcActive = (cw, ch) => {
      const targetRatio = 1920 / 1024;
      const winRatio = cw / ch;
      let activeW, activeH;
      if (winRatio > targetRatio) {
        activeH = ch;
        activeW = ch * targetRatio;
      } else {
        activeW = cw;
        activeH = cw / targetRatio;
      }
      return {
        activeW, activeH,
        baseScale: activeW / 1920,
        activeX: (cw - activeW) / 2,
        activeY: (ch - activeH) / 2,
        globalOffsetY: activeH * 0.05,
      };
    };

    const drawDesk = () => {
      const { cssW: cw, cssH: ch } = cssSize(canvas);
      ctx.clearRect(0, 0, cw, ch);
      ctx2.clearRect(0, 0, cw, ch);
      const { activeW, activeH, baseScale, activeX, activeY, globalOffsetY } = calcActive(cw, ch);

      // desk（奥の机）
      if (deskImageRef.current && deskImageRef.current.complete) {
        const img = deskImageRef.current;
        const w = img.width * baseScale;
        const h = img.height * baseScale;
        const x = activeX + (activeW - w) / 2;
        const y = activeY + activeH - h + globalOffsetY + (600 * baseScale);
        ctx.drawImage(img, x, y, w, h);
      }

      // desk2（最前面の机）
      if (desk2ImageRef.current && desk2ImageRef.current.complete) {
        const img = desk2ImageRef.current;
        const w = img.width * baseScale;
        const h = img.height * baseScale;
        const x = activeX + (activeW - w) / 2;
        const y = activeY + activeH - h + globalOffsetY + (1100 * baseScale);
        ctx2.drawImage(img, x, y, w, h);
      }
    };

    const onImageLoad = () => {
      loadedCount.current++;
      if (loadedCount.current >= 2) resizeCanvas();
      else drawDesk();
    };

    const deskImage = new Image();
    deskImage.onload = () => { deskImageRef.current = deskImage; onImageLoad(); };
    deskImage.onerror = () => { console.error('Failed to load desk image'); onImageLoad(); };
    deskImage.src = '/img/desk.png';

    const desk2Image = new Image();
    desk2Image.onload = () => { desk2ImageRef.current = desk2Image; onImageLoad(); };
    desk2Image.onerror = () => { console.error('Failed to load desk2 image'); onImageLoad(); };
    desk2Image.src = '/img/desk2.png';

    window.addEventListener('resize', resizeCanvas);

    const initCanvas = () => {
      [canvas, canvas2].forEach((c) => {
        sizeCanvas(c, window.innerWidth, window.innerHeight);
      });
    };

    initCanvas();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <>
      <canvas ref={canvasRef} className="desk-canvas" />
      <canvas ref={canvas2Ref} className="desk2-canvas" />
    </>
  );
};

export default DeskCanvas;